import Vue from 'vue';
import axios from "axios";
import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";

const setViolationArchiveStatus = (state, listGroupItemId, categoryId, status) => {
    if (categoryId) {
        const group = state.violationGroups.find((g) => g.id === categoryId);
        const violation = group.items.find((v) => v.id === listGroupItemId);
        violation.is_archive = status;
        const isAnyArchivedItems = group.items.some((i) => i.is_archive === 1);
        if (!isAnyArchivedItems) {
            group.hasFouls = 0;
        }
        return;
    }
    const violation = state.violations.find((s) => s.id.toString() === listGroupItemId.toString());
    violation.is_archive = status;
};

const setQueryParams = (filters, queryParams) => {
    if (filters && filters.name) {
        queryParams.push(`search=${filters.name}`);
    }
};

const findAndUpdateViolationEntity = (violations, updatedViolation) => {
    const violation = violations.find((v) => v.id.toString() === updatedViolation.id.toString());

    Object.keys(updatedViolation).forEach((key) => {
        violation[key] = updatedViolation[key];
    });
};

const state = () => ({
    violationGroups: [],
    violations: [],
    positions: [],
    lastListGroupIdOfCreatedItem: 0,
    lastChangeWasGroupSorting: false,

    collections: {
        violations: [],
    },

    filials: [],
    moneySources: [],
});

const getters = {
    getListGroupItemsByGroupId: (state) => (groupId) => state.violationGroups.find((g) => groupId === g.id).items,
    getViolation: (state) => (violationId) => {
        const violationWithoutGroup = state.violations.find((v) => v.id.toString() === violationId.toString());
        if (violationWithoutGroup) {
            return violationWithoutGroup;
        }

        const groupsViolations = state.violationGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);

        return groupsViolations.find((v) => v.id.toString() === violationId.toString());
    },
    isAnyArchivedItem: (state) => {
        const allViolations = state.violationGroups.reduce((acc, currentGroup) => {
            if (currentGroup.items && currentGroup.items.length) {
                acc = [...acc, ...currentGroup.items];
            }
            return acc;
        }, []);
        return [...state.violations, ...allViolations].some((v) => v.is_archive === 1);
    },
    isAnyItemExists: (state) => state.violations.length || state.violationGroups.length,
    getViolationsCollection: (state) => state.collections.violations,
};

const mutations = {
    setViolations(state, violations) {
        state.violations = violations;
    },
    setViolationsToGroup(state, { id, items }) {
        const group = state.violationGroups.find((group) => group.id === id);
        group.items = items;
    },
    setViolationGroups(state, groups) {
        state.violationGroups = [];
        state.violationGroups = groups.map((group) => {
            return { ...group, items: group.moneySources.length ? group.moneySources : [] };
        });
    },
    putNewViolation(state, { model, categoryId }) {
        const newViolation = {
            ...model,
            is_archive: 0,
        };

        if (categoryId === "null") {
            state.violations.unshift(newViolation);
            return;
        }
        state.lastListGroupIdOfCreatedItem = categoryId;
        const group = state.violationGroups.find((g) => g.id === categoryId);
        group.items.unshift(newViolation);
    },
    putNewViolationGroup(state, group) {
        state.violationGroups.unshift({ ...group, hasFouls: 0, items: [] });
    },
    updateViolation(state, violationData) {
        state.violationGroups.forEach((group) => {
            const idx = group.items.findIndex((item) => item.id.toString() === violationData.id.toString())
            if (idx > -1) {
                group.items = [...group.items.slice(0, idx), ...group.items.slice(idx + 1, group.items.length)]
            }
        });

        const idx = state.violations.findIndex((item) => item.id.toString() === violationData.id.toString())
        if (idx > -1) state.violations = [...state.violations.slice(0, idx), ...state.violations.slice(idx + 1, state.violations.length)]

        if (violationData.category_id === "null") {
            let idx = state.violations.findIndex((item) => {item.id.toString() === violationData.id.toString()})

            if (idx > -1) {
                state.violations = state.violations.map((item) => {
                    if (item.id.toString() === violationData.id.toString()) {
                        return violationData;
                    } else {
                        return item;
                    }
                });
            } else {
                state.violations.unshift(violationData)
            }
        } else {
            state.violationGroups.forEach((group) => {
                if (group.id.toString() === violationData.category_id.toString()) {
                    group.items.unshift(violationData)
                }
            });
        }
    },
    updateViolationGroup(state, updatedGroup) {
        const group = state.violationGroups.find((g) => g.id.toString() === updatedGroup.id.toString());
        Object.keys(group).forEach((key) => {
            if (key in updatedGroup) {
                group[key] = updatedGroup[key];
            }
        });
    },
    deleteListGroupItem(state, { id, categoryId }) {
        if (!categoryId) {
            state.violations = state.violations.filter((s) => s.id !== id);
            return;
        }
        const group = state.violationGroups.find((group) => group.id === categoryId);
        group.items = group.items.filter((i) => i.id !== id);
        if (!group.items.length) {
            group.hasFouls = 0;
            group.hasArchivedItems = 0;
        }
    },
    deleteListGroup(state, id) {
        const groupIndex = state.violationGroups.findIndex((g) => g.id === id);
        state.violationGroups.splice(groupIndex, 1);
    },
    moveListGroupItemToArchive(state, { listGroupItemId, categoryId }) {
        setViolationArchiveStatus(state, listGroupItemId, categoryId, ARCHIVED);
    },
    moveListGroupItemFromArchive(state, { listGroupItemId, categoryId }) {
        setViolationArchiveStatus(state, listGroupItemId, categoryId, NOT_ARCHIVED);
    },
    updateListItemCategory(state, { categoryId, listItem }) {
        const group = state.violationGroups.find((g) => g.id === categoryId);

        if (group) {
            let item = group.items.find((v) => v.id === listItem.id)

            if (item) item.category_id = categoryId;
        }
        
        if (!group) {
            state.violations.find((v) => v.id === listItem.id).category_id = "null";
            return;
        } 
    },
    setLastChangeWasGroupSortingValue(state, value) {
        state.lastChangeWasGroupSorting = value;
    },
    setFilials(state, filials) {
        state.filials = filials;
    },
    setMoneySources(state, moneySources) {
        state.moneySources = moneySources;
    },
};

const actions = {
    async fetchListGroupItems({ rootState, commit }, filters) {
        const token = rootState.authToken;
        
        const queryParams = ["pagination=0"];

        setQueryParams(filters, queryParams);

        const url = addAuthKey(`${apiUrl}?r=api/transaction-type/index&${queryParams.join("&")}&sort=-sort`, token);

        const { data } = await axios.get(url);

        commit("setViolations", data);
    },
    async fetchViolationGroups({ rootState, commit }, filters) {
        const token = rootState.authToken;
        const queryParams = [];

        if (filters) {
            setQueryParams(filters, queryParams);
        }

        const url = addAuthKey(`${apiUrl}/?r=api/money-source-category/index&${queryParams.join("&")}&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setViolationGroups", data);
    },
    async createViolation({ rootState, commit }, violationData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source/create`, token);

        const formData = serialize(violationData);

        const { data } = await axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (data.success) {
            commit("putNewViolation", {
                model: data.model,
                categoryId: violationData.category_id,
            });
        }

        return data.success;
    },
    async createViolationGroup({ rootState, commit }, groupName) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source-category/create`, token);

        const { data } = await axios.post(url, { name: groupName });

        if (data.success) {
            commit("putNewViolationGroup", data.model);
        }

        return data;
    },
    async changeListItemCategory({ rootState, commit }, { categoryId, listItem }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source/update&id=${listItem.id}`, token);

        await axios.put(url, { category_id: categoryId });

        commit("updateListItemCategory", { categoryId, listItem });
    },
    async changeListGroupItemsSort({ rootState }, sortingData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source/update-sort`, token);

        await axios.patch(url, sortingData);
    },
    async deleteListGroupItem({ rootState, commit }, { id, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source/delete&id=${id}`, token);

        const { data } = await axios.post(url);

        if (data.success) {
            commit("deleteListGroupItem", { id, categoryId });
        }
    },
    async deleteListGroup({ rootState, commit }, id) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source-category/delete&id=${id}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteListGroup", id);
        }
    },
    async moveListGroupItemToArchive({ rootState, commit }, { listGroupItemId, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source/archive&id=${listGroupItemId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveListGroupItemToArchive", { listGroupItemId, categoryId });
        }
        return data.success;
    },
    async moveListGroupItemFromArchive({ rootState, commit }, { listGroupItemId, categoryId }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source/archive&id=${listGroupItemId}&is_archive=0`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveListGroupItemFromArchive", { listGroupItemId, categoryId });
        }

        return data.success;
    },
    async updateViolation({ rootState, commit, dispatch }, violationData) {
        
        const token = rootState.authToken;

        const url = addAuthKey(`${apiUrl}?r=api/transaction-type/update&id=${violationData.id}`, token);

        const { data } = await axios.post(url, violationData);

        if (data.success) {
            dispatch("fetchListGroupItems")

            Vue.notify({
                group: "success-message",
                data: {
                    textMessage: `Тип проводки <b>${data.model.name}</b> успешно изменён`,
                },
            });
        }
    },
    async updateViolationGroup({ rootState, commit }, violationGroupData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source-category/update&id=${violationGroupData.id}`, token);

        const { data } = await axios.put(url, violationGroupData);

        if (data.success) {
            commit("updateViolationGroup", data.model);
        }

        return data;
    },
    async updateGroupsSort({ rootState, state, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/money-source-category/update-sort`, token);
        
        const sortingData = state.violationGroups.map((group, groupIndex) => ({
            id: group.id,
            sort: state.violationGroups.length - groupIndex,
        }));

        commit("setLastChangeWasGroupSortingValue", false);

        await axios.patch(url, sortingData);
    },
    async updateSort({ rootState, state }, sortingData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}?r=api/transaction-type/update-sort`, token);

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
    async fetchFilials({ rootState, commit }) {
        const token = rootState.authToken;

        const url = addAuthKey(`${apiUrl}?r=api/transaction-type/filial`, token);

        const { data } = await axios.get(url);

        commit("setFilials", data);
    },
    async fetchMoneySources({ rootState, commit }) {
        const token = rootState.authToken;

        const url = addAuthKey(`${apiUrl}?r=api/money-source/source`, token);

        const { data } = await axios.get(url);

        commit("setMoneySources", data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
